__turbopack_context__.v({
  "card": "style-module-scss-module__eOPnFW__card",
  "cardNumber": "style-module-scss-module__eOPnFW__cardNumber",
  "cardRow": "style-module-scss-module__eOPnFW__cardRow",
  "component": "style-module-scss-module__eOPnFW__component",
  "header": "style-module-scss-module__eOPnFW__header",
  "leftSection": "style-module-scss-module__eOPnFW__leftSection",
  "middleSection": "style-module-scss-module__eOPnFW__middleSection",
  "rightSection": "style-module-scss-module__eOPnFW__rightSection",
  "wrapper": "style-module-scss-module__eOPnFW__wrapper",
});
